import * as PIXI from 'pixi.js';
import {getNearestTierTexture, Ship} from '@game/ships/ship';
import {HullSize, ShipGameObject} from '@game/ships/ship.game-object';
import {ExhaustGameObject} from '@game/ships/parts/exhaust.game-object';
import {ShipCreateOptions} from '@game/ships/ship.factory';

const OFFSET_Y = 30;

export class CorvetteFalconGameObject extends ShipGameObject {

  constructor(ship: Ship, opts: ShipCreateOptions) {
    super(ship, opts);

    const res = PIXI.Loader.shared.resources;

    // Left
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: -1,
      x: -8,
      y: 30 + OFFSET_Y,
      scale: 1.3,
    }));

    // Right
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: 1,
      x: 10,
      y: 30 + OFFSET_Y,
      scale: 1.3,
    }));

    const shipTexture = getNearestTierTexture(ship.getHighestModuleTier(), 'ships', 'corvette_falcon_t%.png')
    if (shipTexture) {
      const sprite = new PIXI.Sprite(shipTexture);
      sprite.y += OFFSET_Y;
      this.addChild(sprite);
    }
  }

  getSize(): number {
    return HullSize.Normal;
  }
}
